import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Tools|Announcements|Details|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Announcements,
	portal: 'SP',
};

export type SPAnnouncementsDetailsLocNames =
	| 'SPAnnouncementsDetailsLabelDisplayOrder'
	| 'SPAnnouncementsDetailsFieldErrorDisplayOrder';

export const spAnnouncementsDetailsLocs: LocDefs<SPAnnouncementsDetailsLocNames> = {
	SPAnnouncementsDetailsLabelDisplayOrder: {
		defaultValue: 'Display Order',
		description: 'Label for Display Order field.',
		displayPath: `${pathStart}Display Order`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPAnnouncementsDetailsFieldErrorDisplayOrder: {
		defaultValue: 'Display order must be a positive whole number',
		description: 'Error message for Display Order field when it is not a positive whole number.',
		displayPath: `${pathStart}Display Order Numeric`,
		displayType: 'Error',
		...sharedProperties,
	},
};

export const LOC_KEYS = MapLocKeys<SPAnnouncementsDetailsLocNames>(spAnnouncementsDetailsLocs);
